export enum ENUM__image_compare_mode {
  NONE = 'none',
  SLIDER = 'slider',
  SIDE_BY_SIDE = 'side_by_side',
  DIFFERENCE = 'difference',
}
